import type { PortalUserAuditLogEntry } from '../../store/modules/merchant/types';

const joinName = (givenName?: string | null, familyName?: string | null): string =>
  [givenName, familyName].filter(Boolean).join(' ').trim();

/**
 * The target user's name for an audit entry, or an empty string when we never captured it.
 *
 * Newer entries store the name on the record itself. Older entries only have it inside the
 * before/after snapshot, so fall back to that — reading `previousValue` for deletes, since a
 * deleted user has no "after" state.
 */
export const getPortalUserAuditTargetName = (auditLog: PortalUserAuditLogEntry): string => {
  const nameOnRecord = joinName(auditLog.givenName, auditLog.familyName);
  if (nameOnRecord) {
    return nameOnRecord;
  }

  const snapshot =
    auditLog.action === 'delete'
      ? auditLog.previousValue
      : (auditLog.newValue ?? auditLog.previousValue);

  return joinName(snapshot?.givenName, snapshot?.familyName);
};
